var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_edit",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.972 28.2l4.2-4.3c2.3-2.3 2.3-6.2 0-8.5l-5.7-5.7c-2.3-2.3-6.1-2.3-8.5 0l-4.2 4.3-1.5 1.5-1.3 1.3-40.9 41.5V72h13.8l41.2-41 1.4-1.4 1.5-1.4zM20.172 68h-8.1v-8l39.7-40.3 8.5 8.5-40.1 39.8zm34.4-51.2l4.2-4.2c.8-.8 2-.8 2.8 0l5.7 5.7c.8.8.8 2.1 0 2.8l-4.2 4.3-8.5-8.6zm5.5 51.2h-28v4h28v-4zm12 0h-7.9v4h7.9v-4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrEdit);
export default __webpack_public_path__ + "static/media/ubr_edit.0bb202cde67af268f7ae1d5da791d75e.svg";
export { ForwardRef as ReactComponent };